import { FC, useEffect, useState } from "react";

import { EventPlace, trackEngagement } from "helpers/analytics";

import { GoogleProvider } from "./GoogleProvider";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Providers } from "./InstructionsModal";
import { MS365Provider } from "./MS365Provider";
import { MSOutlookProvider } from "./MSOutlookProvider";
import { OtherEmailProvider } from "./OtherEmailProvider";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SendInstructions } from "./SendInstructions";

export enum Location {
  Settings = "settings",
  LiveChat = "livechat",
  WelcomeTutorial = "welcome-tutorial",
}

const trackWithLocation = (
  eventName: string,
  location: Location,
  data?: Record<string, unknown>,
  skipWelcome?: boolean
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  switch (location) {
    case Location.LiveChat:
      trackEngagement(`LC settings: ${eventName}`, EventPlace.LiveChat, data);
      break;
    case Location.WelcomeTutorial:
      if (!skipWelcome) {
        trackEngagement(`Welcome tutorial: ${eventName}`, EventPlace.WelcomeTutorial, data);
      }
      break;
    case Location.Settings:
      trackEngagement(`Settings: ${eventName}`, EventPlace.Settings, data);
      break;
    default:
      break;
  }
};

interface IProps {
  inboxAddress: string;
  onForwardingAddressCopy: () => void;
  location?: Location;
}

const ProviderAccordions: FC<IProps> = ({ onForwardingAddressCopy, inboxAddress, location = Location.Settings }) => {
  const [openedProvider, setOpenedProvider] = useState<Providers | null>(null);
  const [formOpened, setFormOpen] = useState(false);

  const closeProvider = (): void => {
    setOpenedProvider(null);
  };

  const handleProviderHeaderClick = (provider: Providers): void => {
    if (openedProvider === provider) {
      closeProvider();
      return;
    }
    setOpenedProvider(provider);
    setFormOpen(false);
  };

  const handleOpenForm = (): void => {
    closeProvider();
    setFormOpen(true);
  };

  const handleCloseForm = (): void => {
    setFormOpen(false);
  };

  const handleSendInstructionToAdmin = (): void => {
    closeProvider();
    setFormOpen(true);
  };

  const handleMailboxCopying = (provider: Providers): void => {
    onForwardingAddressCopy();
    trackWithLocation("Forwarding address copied", location, { provider, inboxAddress });
  };

  useEffect(() => {
    if (inboxAddress !== null) {
      trackWithLocation("Forwarding instructions opened", location, { inboxAddress }, true);
    }
  }, [inboxAddress, location]);

  return (
    <>
      <GoogleProvider
        opened={openedProvider === Providers.Gmail}
        onHeaderClick={() => handleProviderHeaderClick(Providers.Gmail)}
        inboxAddress={inboxAddress}
        handleMailboxCopying={() => handleMailboxCopying(Providers.Gmail)}
      />
      <MSOutlookProvider
        opened={openedProvider === Providers.Outlook}
        onHeaderClick={() => handleProviderHeaderClick(Providers.Outlook)}
        inboxAddress={inboxAddress}
        handleMailboxCopying={() => handleMailboxCopying(Providers.Outlook)}
      />
      <MS365Provider
        opened={openedProvider === Providers.Office}
        onHeaderClick={() => handleProviderHeaderClick(Providers.Office)}
        inboxAddress={inboxAddress}
        handleMailboxCopying={() => handleMailboxCopying(Providers.Office)}
        onSendForwardingClick={handleSendInstructionToAdmin}
      />
      <OtherEmailProvider
        opened={openedProvider === Providers.Other}
        onHeaderClick={() => handleProviderHeaderClick(Providers.Other)}
        inboxAddress={inboxAddress}
        handleMailboxCopying={() => handleMailboxCopying(Providers.Other)}
      />
      <SendInstructions
        opened={formOpened}
        onOpen={handleOpenForm}
        onClose={handleCloseForm}
        location={location}
        trackWithLocation={trackWithLocation}
      />
    </>
  );
};

export default ProviderAccordions;
